const schools = [
    {
        area: "ירושלים",
        institution_code: "177287",
        name: "(דרכי התורה) ישכיל פיהו"
    }
]

export default schools